// extracted by mini-css-extract-plugin
export default {"error":"DataTable_error__6WS9S"};